<template>
  <div class="settings-roles-container m-4">
    <div
      class="d-flex flex-row justify-content-between align-items-center mb-3"
    >
      <h5 class="mb-0">Roles & Permissions</h5>
      <b-button class="pt-2 pb-2" size="sm" @click="addRole" variant="primary"
        >New</b-button
      >
    </div>
    <grid
      :groupFeature="false"
      :columns="columns"
      :autoHeight="true"
      :data="items"
      :columnLines="false"
      :searchFeature="true"
      :stripeFeature="false"
      @finishcelledit="cellEdited"
    ></grid>
    <b-modal
      centered
      ref="form-modal"
      :title="formId ? 'Edit Role' : 'New Role'"
      header-bg-variant="primary"
      header-text-variant="white"
      @ok="submitRole"
      no-close-on-backdrop
      header-class="bg-purple"
      size="md-lg"
      scrollable
    >
      <template v-slot:modal-footer="{ ok, cancel }">
        <b-button variant="secondary" @click="cancel()">
          Cancel
        </b-button>
        <b-button variant="primary" :disabled="!form.name" @click="ok()">
          Save
        </b-button>
      </template>
      <b-row no-gutters>
        <label>Role name</label>
      </b-row>

      <b-form-input
        v-model="form.name"
        maxLength="100"
        class="mb-3 col-4"
      ></b-form-input>

      <div v-if="Object.keys(form.systemPermissions).length > 0">
        <b-button
          size="lg"
          v-b-toggle.collapse-1
          class="mb-3 font-weight-bold col-12 d-flex justify-content-between"
          variant="light"
          >General Access<span class="when-opened"
            ><i class="fa fa-chevron-up" aria-hidden="true"></i></span
          ><span class="when-closed"
            ><i class="fa fa-chevron-down" aria-hidden="true"></i></span
        ></b-button>
        <b-collapse id="collapse-1" visible>
          <b-row class="permissions-container p-3">
            <b-col
              v-for="(chunk, chunkIndex) in chunks(generalModules, 3)"
              :key="chunkIndex"
              ><b-form-group
                v-for="module in chunk"
                :key="module"
                v-show="module != 'labs' || systemSetting.labEnable"
              >
                <div class="d-flex">
                  <vue-toggles
                    @click="changeSystemVueToggle(module)"
                    :value="form.systemPermissions[module].hasAccess"
                    height="25"
                    width="40"
                    checkedBg="#34C759"
                    uncheckedBg="#FF6161"
                  />
                  <small class="ml-3">{{
                    getPermissionLabel(`m_${module}`)
                  }}</small>
                </div>
              </b-form-group>
            </b-col>
          </b-row>
        </b-collapse>
      </div>
      <div v-if="showModulePermissions('patients')">
        <b-button
          size="lg"
          v-b-toggle.collapse-2
          class="mb-3 font-weight-bold col-12 d-flex justify-content-between"
          variant="light"
          >Patient Permissions<span class="when-opened"
            ><i class="fa fa-chevron-up" aria-hidden="true"></i></span
          ><span class="when-closed"
            ><i class="fa fa-chevron-down" aria-hidden="true"></i></span
        ></b-button>
        <b-collapse id="collapse-2" visible>
          <b-row class="permissions-container p-3">
            <b-col
              v-for="(chunk, chunkIndex) in chunks(
                Object.keys(form.systemPermissions.patients?.access),
                3
              )"
              :key="chunkIndex"
              ><b-form-group v-for="module in chunk" :key="module">
                <div class="d-flex">
                  <vue-toggles
                    @click="changePatientVueToggle(module)"
                    :value="form.systemPermissions.patients.access[module]"
                    height="25"
                    width="40"
                    checkedBg="#34C759"
                    uncheckedBg="#FF6161"
                  />
                  <small class="col-9">{{
                    getPermissionLabel(`p_${module}`)
                  }}</small>
                </div>
              </b-form-group>
            </b-col>
          </b-row>
        </b-collapse>
      </div>

      <div v-if="showModulePermissions('settings')">
        <b-button
          size="lg"
          v-b-toggle.collapse-3
          class="mb-3 font-weight-bold col-12 d-flex justify-content-between"
          variant="light"
          >Configuration Access<span class="when-opened"
            ><i class="fa fa-chevron-up" aria-hidden="true"></i></span
          ><span class="when-closed"
            ><i class="fa fa-chevron-down" aria-hidden="true"></i></span
        ></b-button>
        <b-collapse id="collapse-3" visible>
          <b-row class="permissions-container p-3">
            <b-col
              v-for="(chunk, chunkIndex) in chunks(
                Object.keys(form.systemPermissions.settings?.access),
                3
              )"
              :key="chunkIndex"
              ><b-form-group v-for="module in chunk" :key="module">
                <div class="d-flex">
                  <vue-toggles
                    @click="changeSettingVueToggle(module)"
                    :value="form.systemPermissions.settings.access[module]"
                    height="25"
                    width="40"
                    checkedBg="#34C759"
                    uncheckedBg="#FF6161"
                  />
                  <small class="ml-3">{{
                    getPermissionLabel(`p_${module}`)
                  }}</small>
                </div>
              </b-form-group>
            </b-col>
          </b-row>
        </b-collapse>
      </div>

      <div v-if="showModulePermissions('others')">
        <b-button
          size="lg"
          v-b-toggle.collapse-5
          class="mb-3 font-weight-bold col-12 d-flex justify-content-between"
          variant="light"
          >Other Permissions<span class="when-opened"
            ><i class="fa fa-chevron-up" aria-hidden="true"></i></span
          ><span class="when-closed"
            ><i class="fa fa-chevron-down" aria-hidden="true"></i></span
        ></b-button>
        <b-collapse id="collapse-5" visible>
          <b-row class="permissions-container p-3">
            <b-col
              v-for="(chunk, chunkIndex) in chunks(
                Object.keys(form.systemPermissions.others?.access),
                3
              )"
              :key="chunkIndex"
              ><b-form-group v-for="module in chunk" :key="module">
                <div class="d-flex">
                  <vue-toggles
                    @click="changeOtherVueToggle(module)"
                    :value="form.systemPermissions.others.access[module]"
                    height="25"
                    width="40"
                    checkedBg="#34C759"
                    uncheckedBg="#FF6161"
                  />
                  <small class="ml-3">{{
                    getPermissionLabel(`p_${module}`)
                  }}</small>
                </div>
              </b-form-group>
            </b-col>
          </b-row>
        </b-collapse>
      </div>
      <div>
        <b-button
          size="lg"
          v-b-toggle.collapse-4
          class="mb-3 font-weight-bold col-12 d-flex justify-content-between"
          variant="light"
          >Document Permissions<span class="when-opened"
            ><i class="fa fa-chevron-up" aria-hidden="true"></i></span
          ><span class="when-closed"
            ><i class="fa fa-chevron-down" aria-hidden="true"></i></span
        ></b-button>
        <b-collapse id="collapse-4" visible>
          <b-row class="permissions-container p-3">
            <b-table
              v-if="Object.keys(form.documentsPermissions).length > 0"
              class="w-100"
              :fields="[
                { key: 'document', label: 'Document' },
                {
                  key: 'read_only',
                  label: 'Read',
                  thStyle: { width: '100px' },
                  class: 'word-break-initial text-center'
                },
                {
                  key: 'access_entry',
                  label: 'Create/Edit',
                  class: 'word-break-initial text-center'
                },
                {
                  key: 'review_complete',
                  label: 'Complete/Unlock',
                  class: 'word-break-initial text-center'
                }
              ]"
              :items="documentItems"
              :sticky-header="'450px'"
            >
              <template v-slot:cell(document)="data">
                {{ data.value }}
              </template>
              <template v-slot:cell(read_only)="data">
                <vue-toggles
                  class="toggle-center"
                  @click="
                    changeDocumentsVueToggle(
                      data.item.id,
                      'isReadOnly',
                      data.item.type
                    )
                  "
                  :value="
                    form.documentsPermissions[data.item.id]
                      ? form.documentsPermissions[data.item.id].isReadOnly
                      : false
                  "
                  height="25"
                  width="40"
                  checkedText=""
                  uncheckedText=""
                  checkedBg="#34C759"
                  uncheckedBg="#FF6161"
                />
              </template>
              <template v-slot:cell(access_entry)="data">
                <vue-toggles
                  class="toggle-center"
                  @click="
                    changeDocumentsVueToggle(
                      data.item.id,
                      'hasEntryAccess',
                      data.item.type
                    )
                  "
                  :value="
                    form.documentsPermissions[data.item.id]
                      ? form.documentsPermissions[data.item.id].hasEntryAccess
                      : false
                  "
                  height="25"
                  width="40"
                  checkedText=""
                  uncheckedText=""
                  checkedBg="#34C759"
                  uncheckedBg="#FF6161"
                />
              </template>
              <template v-slot:cell(review_complete)="data">
                <vue-toggles
                  class="toggle-center"
                  @click="
                    changeDocumentsVueToggle(
                      data.item.id,
                      'hasCompleteAccess',
                      data.item.type
                    )
                  "
                  :value="
                    form.documentsPermissions[data.item.id].hasCompleteAccess
                  "
                  height="25"
                  width="40"
                  checkedText=""
                  uncheckedText=""
                  checkedBg="#34C759"
                  uncheckedBg="#FF6161"
                />
              </template>
            </b-table>
          </b-row>
        </b-collapse>
      </div>
      <div>
        <b-button
          size="lg"
          v-b-toggle.collapse-6
          class="mb-3 font-weight-bold col-12 d-flex justify-content-between"
          variant="light"
          >Reports Permissions<span class="when-opened"
            ><i class="fa fa-chevron-up" aria-hidden="true"></i></span
          ><span class="when-closed"
            ><i class="fa fa-chevron-down" aria-hidden="true"></i></span
        ></b-button>
        <b-collapse id="collapse-6" visible>
          <b-row class="permissions-container p-3">
            <b-table
              v-if="Object.keys(form.reportPermissions).length > 0"
              class="w-100"
              :fields="[
                { key: 'name', label: 'Report' },
                {
                  key: 'has_access',
                  label: 'Generate/View',
                  class: 'word-break-initial text-center'
                }
              ]"
              :items="reportItems"
              :sticky-header="'450px'"
            >
              <template v-slot:cell(name)="data">
                {{ data.value }}
              </template>
              <template v-slot:cell(has_access)="data">
                <vue-toggles
                  class="toggle-center"
                  :value="
                    form.reportPermissions[data.item.url]?.hasAccess ?? false
                  "
                  @click="
                    form.reportPermissions[data.item.url].hasAccess = !form
                      .reportPermissions[data.item.url].hasAccess
                  "
                  height="25"
                  width="40"
                  checkedText=""
                  uncheckedText=""
                  checkedBg="#34C759"
                  uncheckedBg="#FF6161"
                />
              </template>
            </b-table>
          </b-row>
        </b-collapse>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Grid from "../../third_party/grid/Grid.vue";
import roleServer from "../../server/role";
import reportServer from "../../server/report";
import formGroupServer from "../../server/formGroup";
import { mapState, mapActions, mapGetters } from "vuex";
import { chunks } from "../../helpers/general";

const permissionLabels = {
  m_documents: "Documents",
  m_patients: "Patients",
  m_providers: "Providers",
  m_settings: "Configuration",
  // m_supervision: "Supervision",

  m_calendar: "Scheduler",
  m_labs: "Labs",
  m_appointmentRequest: "Appointment Requests",
  m_groups: "Groups",
  m_bedBoard: "Occupancy",
  m_ur: "UR",
  m_caseLoad: "Case Load",
  m_reports: "Reports",
  m_mars: "MARS",
  m_attendance: "Attendance",
  m_auditLogs: "Audit Logs",
  m_billing: "Billing",
  m_eligibility: "Eligibility",
  m_availability: "Provider Availability",
  m_messages: "Patient Messages",
  p_create: "Can create patients",
  p_locations: "Locations",
  p_states: "States",
  p_maritalStatus: "Marital Status",
  p_genders: "Legal Sexes",
  p_pronouns: "Pronoun",
  p_sexes: "Sexes",
  p_levelsOfCare: "Levels Of Care",
  p_allergyTypes: "Allergy Types",
  p_allergySeveritys: "Allergy Severities",
  p_relationships: "Relationships",
  p_insuranceTypes: "Insurance Types",
  p_insuranceStatus: "Insurance Statuses",
  p_planTypes: "Plan Types",
  p_forms: "Forms",
  p_roles: "Roles",
  p_users: "Users",
  p_collections: "Collections",
  p_caseRoles: "Case Roles",
  p_nutritionCategories: "Nutrition Categories",
  p_nutritionMeals: "Nutrition Meals",
  p_allergens: "Allergens",
  p_reactions: "Reactions",
  p_insuranceCompanies: "Insurance Companies",
  p_icdCodes: "ICD Codes",
  p_urReviewType: "UR Review Types",
  p_urStatus: "Utilization Status",
  p_ssn: "Can see SSN",
  p_setPasswords: "Set Passwords",
  p_medication: "Medications",
  p_medicationRoute: "Medication Routes",
  p_unitOfMeasurement: "Unit of Measurements",
  p_services: "Services",
  p_facilityInfo: "Organization Information",
  p_badge: "Patient Badges",
  p_badgeCategory: "Patient Badge Categories",
  p_race: "Race",
  p_ethnicity: "Ethnicity",
  p_language: "Language",
  p_ePrescribe: "Can see E-Prescribe",
  p_scheduleEventType: "Event Types",
  p_service: "Services",
  p_medications: "Can see Medications",
  p_doctorOrder: "Can see Doctor Order",
  p_movePatient: "Move Patient",
  p_calendar: "Can see Patient Calendar",
  p_badgesAlerts: "Can see Badges/Alerts",
  p_diagnosisCodes: "Can see Diagnosis codes",
  p_vitals: "Can see Vitals",
  p_nutritionalJournal: "Can see Nutritional Journal",
  p_masterTreatmentPlan: "Can see Treatment Plans",
  p_editAllNotes: "Can edit all notes",
  p_seeAllPatients: "Can see all patients, not only those in user's Case Load",
  p_manageNewPatient: "Can manage new patient requests",
  p_omt: "Can see Outcome Measurement Tools",
  p_rooms: "Rooms",
  p_dischargeReasons: "Discharge Reasons",
  p_patientPortal: "Patient Portal",
  p_organization: "Organization",
  p_patientBillingInfo: "Can see costs and patient billing info",
  p_toDoItemsSeeAll: "Can see all to dos",
  p_toDoItemsComplete: "Can complete to dos",
  p_clinicalService: "Clinical Service",
  p_careAppointmentType: "Care Appointment Type",
  p_credentials: "Credentials",
  p_releaseOfInformation: "Can see Release of Information",
  p_editChargedEvents: "Can edit charged events"
};

export default {
  name: "RoleCrud",
  components: {
    Grid
  },
  data() {
    return {
      modules: {},
      reports: [],
      formId: null,
      form: {
        name: "",
        copy: false,
        roleId: null,
        systemPermissions: {},
        documentsPermissions: {},
        reportPermissions: {}
      }
    };
  },
  mounted() {
    this.fetchRoles();
    this.getModules();
    this.getReports();
    this.fetchFormBuilderForms({ category: "main" });
    this.fetchFormBuilderForms({ category: "masterTreatmentPlan" });
    this.fetchFormGroups();
  },
  methods: {
    ...mapActions("layout", ["showAlertSuccess", "showError"]),
    ...mapActions("layout", ["fetchRoles"]),
    ...mapActions("formBuilder", ["fetchFormBuilderForms"]),
    ...mapActions("formGroup", ["fetchFormGroups"]),
    async getModules() {
      this.modules = await roleServer.getModules();
    },
    async getReports() {
      this.reports = await reportServer.query();
    },
    async submitRole() {
      const formData = {
        name: this.form.name,
        systemPermissions: this.form.systemPermissions,
        documentsPermissions: this.form.documentsPermissions,
        reportPermissions: this.form.reportPermissions
      };
      if (this.formId) {
        await roleServer.update(this.formId, formData);
      } else {
        if (this.form.copy) {
          await roleServer.copyFrom({
            name: this.form.name,
            sourceRole: this.form.roleId
          });
        } else {
          await roleServer.create(formData);
        }
      }
      await this.fetchRoles();
      if (this.formId && this.formId == this.currentUser.role.id)
        this.currentUser.role = this.list.find(r => r.id == this.formId);
      this.showAlertSuccess();
    },
    changeSystemVueToggle(moduleObj) {
      const newSystemPermissions = { ...this.form.systemPermissions };
      newSystemPermissions[moduleObj].hasAccess = !newSystemPermissions[
        moduleObj
      ].hasAccess;
      this.form.systemPermissions = newSystemPermissions;
    },
    changePatientVueToggle(moduleObj) {
      const newSystemPermissions = { ...this.form.systemPermissions };
      newSystemPermissions.patients.access[moduleObj] = !newSystemPermissions
        .patients.access[moduleObj];

      this.form.systemPermissions = newSystemPermissions;
    },
    changeSettingVueToggle(moduleObj) {
      const newSystemPermissions = { ...this.form.systemPermissions };
      newSystemPermissions.settings.access[moduleObj] = !newSystemPermissions
        .settings.access[moduleObj];

      this.form.systemPermissions = newSystemPermissions;

      this.form.systemPermissions["settings"].hasAccess =
        Object.entries(newSystemPermissions.settings.access).filter(
          item => item[1] == true
        ).length > 0
          ? true
          : false;
    },
    changeOtherVueToggle(moduleObj) {
      const newSystemPermissions = { ...this.form.systemPermissions };
      newSystemPermissions.others.access[moduleObj] = !newSystemPermissions
        .others.access[moduleObj];

      this.form.systemPermissions = newSystemPermissions;
    },
    async changeDocumentsVueToggle(formId, field, type) {
      const newDocumentsPermissions = { ...this.form.documentsPermissions };
      newDocumentsPermissions[formId][field] = !newDocumentsPermissions[formId][
        field
      ];
      if (type == "formGroup") {
        const formGroup = await formGroupServer.get(formId);
        for (let index = 0; index < formGroup.formIds.length; index++) {
          const fId = formGroup.formIds[index];
          newDocumentsPermissions[fId][field] =
            newDocumentsPermissions[formId][field];
        }
      }
      this.form.documentsPermissions = newDocumentsPermissions;

      if (
        field == "hasEntryAccess" &&
        newDocumentsPermissions[formId][field] &&
        !newDocumentsPermissions[formId]["isReadOnly"]
      ) {
        this.changeDocumentsVueToggle(formId, "isReadOnly", type);
      } else if (
        field == "hasCompleteAccess" &&
        newDocumentsPermissions[formId][field] &&
        !newDocumentsPermissions[formId]["hasEntryAccess"]
      ) {
        this.changeDocumentsVueToggle(formId, "hasEntryAccess", type);
      } else if (
        field == "hasEntryAccess" &&
        !newDocumentsPermissions[formId][field] &&
        newDocumentsPermissions[formId]["hasCompleteAccess"]
      ) {
        this.changeDocumentsVueToggle(formId, "hasCompleteAccess", type);
      } else if (
        field == "isReadOnly" &&
        !newDocumentsPermissions[formId][field] &&
        newDocumentsPermissions[formId]["hasEntryAccess"]
      ) {
        this.changeDocumentsVueToggle(formId, "hasEntryAccess", type);
      }
    },
    addRole() {
      this.formId = null;
      this.form = {
        name: "",
        copy: false,
        roleId: null,
        systemPermissions: this.populateSystemPermissions({}),
        documentsPermissions: this.populateDocumentPermissions({}),
        reportPermissions: this.populateReportPermissions({})
      };
      this.$refs["form-modal"].show();
    },
    populateSystemPermissions(systemPermissions) {
      for (let index = 0; index < Object.keys(this.modules).length; index++) {
        const moduleKey = Object.keys(this.modules)[index];
        if (!systemPermissions[moduleKey]) {
          let hasAccess = moduleKey === "others";
          systemPermissions[moduleKey] = {
            hasAccess: hasAccess,
            access: {}
          };
        } else if (
          moduleKey === "others" &&
          !systemPermissions[moduleKey].hasAccess
        )
          systemPermissions[moduleKey].hasAccess = true;
        for (
          let index2 = 0;
          index2 < this.modules[moduleKey].length;
          index2++
        ) {
          const permission = this.modules[moduleKey][index2];
          if (!systemPermissions[moduleKey].access[permission]) {
            systemPermissions[moduleKey].access[permission] = false;
          }
        }
      }
      return systemPermissions;
    },
    populateDocumentPermissions(documentsPermissions) {
      for (let index = 0; index < this.forms.length; index++) {
        const form = this.forms[index];
        if (!documentsPermissions[form.id]) {
          documentsPermissions[form.id] = {
            hasEntryAccess: true,
            hasCompleteAccess: true,
            isReadOnly: true
          };
        }
      }
      for (let index = 0; index < this.formGroups.length; index++) {
        const formGroup = this.formGroups[index];
        if (!documentsPermissions[formGroup.id]) {
          documentsPermissions[formGroup.id] = {
            hasEntryAccess: true,
            hasCompleteAccess: true,
            isReadOnly: true
          };
        }
      }
      return documentsPermissions;
    },
    populateReportPermissions(reportPermissions) {
      for (let report of this.reports) {
        if (!reportPermissions[report.url]) {
          reportPermissions[report.url] = {
            hasAccess: false
          };
        }
      }
      return reportPermissions;
    },
    getPermissionLabel(permissionKey) {
      return permissionLabels[permissionKey]
        ? permissionLabels[permissionKey]
        : permissionKey;
    },
    async cellEdited(event) {
      const record = event.editorContext.record.data;
      await roleServer.update(record.id, {
        name: record.name
      });
      this.fetchRoles();
    },
    chunks(values, chunkCount) {
      return chunks(values, chunkCount);
    },
    showModulePermissions(moduleKey) {
      let obj = this.form.systemPermissions[moduleKey]?.access || {};
      return Object.keys(obj).length > 0;
    }
  },
  computed: {
    ...mapGetters("layout", ["isTechStaff"]),
    ...mapState("layout", {
      systemSetting: state => state.systemSetting,
      currentUser: state => state.currentUser
    }),
    ...mapState("formBuilder", {
      forms: state => [
        ...state.list["main"],
        ...state.list["groupSession"],
        ...state.list["masterTreatmentPlan"],
        ...state.list["releaseOfInformation"]
      ]
    }),
    ...mapState("formGroup", {
      formGroups: state => state.list
    }),
    ...mapState("layout", {
      list: state => state.roles
    }),
    generalModules() {
      return Object.keys(this.modules).filter(module => module !== "others");
    },
    documentItems: {
      get() {
        return [
          ...this.formGroups.map(formGroup => ({
            id: formGroup.id,
            document: formGroup.name,
            type: "formGroup",
            access_entry: this.form.documentsPermissions[formGroup.id]
              ? this.form.documentsPermissions[formGroup.id].hasEntryAccess
              : false,
            review_complete: this.form.documentsPermissions[formGroup.id]
              ? this.form.documentsPermissions[formGroup.id].hasCompleteAccess
              : false,
            read_only: this.form.documentsPermissions[formGroup.id]
              ? this.form.documentsPermissions[formGroup.id].isReadOnly
              : false
          })),
          ...this.forms.map(form => ({
            id: form.id,
            document: form.name,
            type: "form",
            access_entry: this.form.documentsPermissions[form.id]
              ? this.form.documentsPermissions[form.id].hasEntryAccess
              : true,
            review_complete: this.form.documentsPermissions[form.id]
              ? this.form.documentsPermissions[form.id].hasCompleteAccess
              : true,
            read_only: this.form.documentsPermissions[form.id]
              ? this.form.documentsPermissions[form.id].isReadOnly
              : false
          }))
        ].sort((a, b) => a.document.localeCompare(b.document));
      }
    },
    reportItems() {
      return this.reports
        .map(report => ({
          url: report.url,
          name: report.displayName
        }))
        .sort((a, b) => a.name.localeCompare(b.name));
    },
    items() {
      return this.list
        .filter(r => r.name != "Tech Staff")
        .map(item => ({
          ...item
        }));
    },
    columns() {
      let columns = [
        {
          text: "Name",
          field: "name",
          flex: 1,
          editor: false
        },
        {
          text: "",
          type: "action",
          cellCls: "pointer-cell",
          field: "action",
          align: "right",
          width: 400,
          actions: [
            {
              tooltip: "Edit",
              renderer: () =>
                `<img class="b-action-item" src="${
                  this.isStandalone()
                    ? `/icons/edit.svg`
                    : `/desktop/icons/edit.svg`
                }">`,
              onClick: ({ record }) => {
                this.fetchRoles();
                this.formId = record.id;
                this.form = {
                  name: record.name,
                  systemPermissions: this.populateSystemPermissions(
                    record.systemPermissions
                  ),
                  documentsPermissions: this.populateDocumentPermissions(
                    record.documentsPermissions
                  ),
                  reportPermissions: this.populateReportPermissions(
                    record.reportPermissions
                  )
                };
                this.$refs["form-modal"].show();
              }
            },
            {
              tooltip: "Delete",
              renderer: () =>
                `<img class="b-action-item ml-2 mr-1" src="${
                  this.isStandalone()
                    ? `/icons/delete.svg`
                    : `/desktop/icons/delete.svg`
                }">`,
              onClick: ({ record }) => {
                this.$dialog
                  .confirm(
                    {
                      title: "Are you sure you want to delete this record?"
                    },
                    {
                      view: "confirm-delete"
                    }
                  )
                  .then(async () => {
                    await roleServer.delete(record.id);
                    this.fetchRoles();
                    this.showAlertSuccess();
                  })
                  .catch(error => {
                    this.showError({
                      message: error.response.data
                    });
                  });
              }
            }
          ]
        }
      ];
      return columns;
    },
    roles() {
      return this.list
        .filter(r => r.name != "Tech Staff")
        .map(r => ({
          value: r.id,
          text: r.name
        }));
    }
  }
};
</script>

<style scoped>
.toggle-center {
  margin-left: auto;
  margin-right: auto;
}

.collapsed > .when-opened,
:not(.collapsed) > .when-closed {
  display: none;
}
</style>

<style>
.settings-roles-container .b-grid-container .b-container {
  max-height: calc(100vh - 281px) !important;
}
</style>
